import React, { Component } from 'react';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import FullbleedHero from '../components/ContentBlocks/FullbleedHero';
import ContactForm from '../components/ContactForm';
import { fetchContact } from '../redux/actions';
import { connect } from 'react-redux';
import Loader from '../components/Loader';
import './ContactPage.css';
import ReactMarkdown from 'react-markdown';
import Helmet from 'react-helmet';

class ContactPage extends Component {

  componentDidMount()
  {
    const locale = this.props.intl.locale;
    if (!this.props.contact.header) {
      this.props.fetchContact(locale);
    }
  }

  render() {
    const contact = this.props.contact;

    return (
      <div className="contact">
        <Helmet>
          <title>{this.props.intl.messages["header.contactUs"]}</title>
        </Helmet>
        {!contact.header && <Loader/>}
        {contact.header && <FullbleedHero fields={contact.header}/>}
        <div className="contact-body">
          <div className="container">
            <div className="row">
              <div id="open-hours" className="left-column">
                <h2 className="cacheover"><FormattedMessage id="footer.openTitle" /></h2>
                {contact.leftColumn && <ReactMarkdown source={contact.leftColumn} softBreak="br" />}
              </div>
              <div className="right-column">
                <ContactForm />
                {contact.rightColumn && <ReactMarkdown source={contact.rightColumn} softBreak="br" />}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ContactPage.propTypes = {
  intl: intlShape.isRequired,
}

const mapStateToProps = state => ({
  contact:state.contact,
  hours:state.hours
});

const mapDispatchToProps = {
  fetchContact
};

export default connect(mapStateToProps,mapDispatchToProps)(injectIntl(ContactPage));



// WEBPACK FOOTER //
// ./src/containers/ContactPage.js